import React from "react";

import {
  FaPlus,
  FaSearch,
} from "react-icons/fa";

import Button from "../../../../components/Button/Button";

export default function ActeursFiltersBar({
  searchTerm,
  setSearchTerm,

  selectedGroupId,
  setSelectedGroupId,

  linkFilter,
  setLinkFilter,

  groups,

  onReset,
  onCreate,

  loading,
}) {
  return (
    <div className="rounded-3xl border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="grid gap-3 xl:grid-cols-[minmax(260px,1fr),250px,220px,auto]">
        {/* Recherche */}
        <div className="relative">
          <FaSearch className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />

          <input
            className="h-11 w-full rounded-2xl border border-slate-300 bg-white pl-10 pr-4 text-sm text-slate-900 outline-none transition focus:border-indigo-500 focus:ring-4 focus:ring-indigo-500/10 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
            type="text"
            placeholder="Acteur, club, email ou utilisateur lié..."
            value={searchTerm}
            onChange={(event) =>
              setSearchTerm(event.target.value)
            }
          />
        </div>

        {/* Filtre par groupe */}
        <select
          className="h-11 w-full rounded-2xl border border-slate-300 bg-white px-4 text-sm text-slate-900 outline-none transition focus:border-indigo-500 focus:ring-4 focus:ring-indigo-500/10 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
          value={selectedGroupId}
          onChange={(event) =>
            setSelectedGroupId(
              event.target.value,
            )
          }
        >
          <option value="">
            Tous les groupes
          </option>

          {groups.map((group) => (
            <option
              key={group.id}
              value={String(group.id)}
            >
              {group.nom}
            </option>
          ))}
        </select>

        {/* Filtre par liaison */}
        <select
          className="h-11 w-full rounded-2xl border border-slate-300 bg-white px-4 text-sm text-slate-900 outline-none transition focus:border-indigo-500 focus:ring-4 focus:ring-indigo-500/10 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
          value={linkFilter}
          onChange={(event) =>
            setLinkFilter(event.target.value)
          }
        >
          <option value="all">
            Tous les acteurs
          </option>

          <option value="linked">
            Avec compte utilisateur
          </option>

          <option value="unlinked">
            Sans compte utilisateur
          </option>
        </select>

        {/* Actions */}
        <div className="flex flex-wrap items-center justify-end gap-2">
          <button
            type="button"
            onClick={onReset}
            disabled={loading}
            className="inline-flex h-11 items-center gap-2 rounded-2xl border border-slate-300 bg-white px-4 text-sm font-medium text-slate-700 transition hover:bg-slate-50 disabled:opacity-50 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200 dark:hover:bg-slate-800"
          >
            Réinitialiser
          </button>

          <Button
            text="Ajouter"
            onClick={onCreate}
            icon={FaPlus}
            className="!h-11 !rounded-2xl !px-4"
          />
        </div>
      </div>
    </div>
  );
}